"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputContainer = exports.WeekDaysContainer = exports.WeekDay = exports.Week = exports.Title = exports.StyledIcon = exports.Overlay = exports.Day = exports.Close = exports.Calendar = exports.Arrow = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("color"));

var _widths = require("../../../../styles/widths");

var _palette = require("../../../../styles/palette");

var _index = _interopRequireDefault(require("../../Icon/index"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

var Arrow = (0, _styledComponents["default"])(_index["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  &:hover {\n    cursor: pointer;\n  }\n"])));
exports.Arrow = Arrow;
Arrow.displayName = 'Arrow';

var Calendar = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 350px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background: ", ";\n  transform: translate(-50%,-50%);\n  width: calc(100% - ", "px);\n  padding: 0 0 20px 0;\n  border-radius: ", "px;\n  z-index: 9999;\n"])), _palette.palette.white, _widths.widths.base * 2, _widths.widths.base);

exports.Calendar = Calendar;
Calendar.displayName = 'Calendar';

var Close = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-around;\n"])));

exports.Close = Close;
Close.displayName = 'Close';

var Day = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 40px;\n  height: 40px;\n  display: flex;\n  color: ", ";\n  background: ", ";\n  border-radius: 50px;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  pointer-events: ", ";\n  &:hover {\n    background: ", ";\n    outline: none;\n    cursor: pointer;\n  }\n  &:focus {\n    outline: none;\n  }\n"])), function (props) {
  return props.current ? _palette.palette.white : props.disabled ? (0, _color["default"])(_palette.palette.bobBlack).fade(0.7).toString() : _palette.palette.bobBlack;
}, function (props) {
  return props.current ? _palette.palette.primary : 'none';
}, function (props) {
  return props.disabled && !props.nextMonth ? 'none' : 'auto';
}, function (props) {
  return props.current ? _palette.palette.primary : 'none';
});

exports.Day = Day;
Day.displayName = 'Day';

var Overlay = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  background: rgba(0, 0, 0, 0.5);\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99;\n"])));

exports.Overlay = Overlay;
Overlay.displayName = 'Overlay';
var StyledIcon = (0, _styledComponents["default"])(_index["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  left: 0;\n  top: 20px;\n"])));
exports.StyledIcon = StyledIcon;
StyledIcon.displayName = 'StyledIcon';

var Title = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  font-weight: ", ";\n  text-transform: capitalize;\n  justify-content: space-between;\n  height: 50px;\n  & > div:first-of-type {\n    margin-left: ", "px;\n  }\n  & > div:last-of-type {\n    margin-right: ", "px;\n  }\n"])), _widths.font.semi, _widths.widths.base * 2, _widths.widths.base * 2);

exports.Title = Title;
Title.displayName = 'Title';

var Week = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 14px;\n  font-weight: ", ";\n  text-transform: uppercase;\n  display: flex;\n  max-width: 280px;\n  margin: 0 auto;\n  & span {\n    width: 40px;\n    height: 40px;\n  }\n"])), _widths.font.semi);

exports.Week = Week;
Week.displayName = 'Week';

var WeekDay = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

exports.WeekDay = WeekDay;
WeekDay.displayName = 'WeekDay';

var WeekDaysContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 280px;\n  margin: 0 auto;\n  height: 260px;\n"])));

exports.WeekDaysContainer = WeekDaysContainer;
WeekDaysContainer.displayName = 'WeekDaysContainer';

var InputContainer = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  min-height: ", "px;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  max-width: ", ";\n  & label {\n    position: absolute;\n    line-height: 22px;\n    left: ", "px;\n    top: ", ";\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    z-index: 1;\n    pointer-events: none;\n    user-select: none;\n    font-size: ", "px;\n    color: ", ";\n    font-weight: ", ";\n  }\n  & input {\n    position: absolute;\n    background-color: transparent;\n    border: none;\n    left: 0;\n    bottom: 5px;\n    font-size: 16px;\n    font-weight: ", ";\n    line-height: 22px;\n    width: calc(100% - ", "px);\n    border-radius: 0;\n    padding: 0 0 7px 0;\n    padding-left: ", "px;\n    transition: border-bottom 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    border-bottom: ", ";\n    &:focus {\n      outline: none;\n      border-radius: 0;\n    }\n  }\n  & span {\n    position: absolute;\n    left: 0;\n    margin-top: 8px;\n    bottom: -20px;\n    z-index: 1;\n    line-height: 16px;\n    color: ", ";\n    font-size: 12px;\n  }\n"])), _widths.widths.base * 7, _widths.widths.base, _widths.widths.base * 4, function (props) {
  return props.width ? typeof props.width === 'string' ? props.width : "".concat(props.width, "px") : 'none';
}, function (props) {
  return props.active || props.dirty ? 0 : props.icon ? _widths.widths.base * 4 : 0;
}, function (props) {
  return props.active || props.dirty ? 0 : 'calc(100% - 35px)';
}, function (props) {
  return props.active || props.dirty ? 12 : 16;
}, function (props) {
  return props['data-error'] ? _palette.palette.error : props.active ? _palette.palette.link : _palette.palette.bobBlack;
}, _widths.font.regular, _widths.font.regular, _widths.widths.base * 4, function (props) {
  return props.icon ? _widths.widths.base * 4 : 0;
}, function (props) {
  return props['data-error'] ? "solid 1px ".concat(_palette.palette.error) : props.active ? "solid 1px ".concat(_palette.palette.link) : "solid 1px ".concat(_palette.palette.bobBlack);
}, function (props) {
  return props['data-error'] ? _palette.palette.error : _palette.palette.grey;
});

exports.InputContainer = InputContainer;
InputContainer.displayName = 'InputContainer';